import { useMutation, useQueryCache } from "react-query";
import { getInspectionQueryKey } from "./useInspection";
import { useToasts } from "react-toast-notifications";
import { postInspectionStartedAt } from "../../api/inspections/postInspectionStartedAt";
import useNetworkHeaders from "../../../../hooks/useNetworkHeaders";
import { ToastStatuses } from "../../../../components/global_components/Toast";

interface Params {
  id: number | string;
}
export default function useCreateInspectionStartedAt({ id }: Params) {
  const queryCache = useQueryCache();
  const { addToast } = useToasts();
  const inspectionQueryKey = getInspectionQueryKey(id);

  const networkHeaders = useNetworkHeaders();
  const [createInspectionStartedAt, createInspectionStartedAtState] = useMutation(
    postInspectionStartedAt(networkHeaders, Number(id)),
    {
      onSuccess: () => {
        addToast("Inspection Started!", { autoDismiss: true, appearance: ToastStatuses.Success });
        queryCache.invalidateQueries(inspectionQueryKey);
      },
      onError: (data) => {
        const errorData = data as { error?: { statusCode?: number; error?: string; message?: string } };
        // Bit of hack to get this error message in here. Might want to change later...
        if (errorData?.error?.statusCode === 403) {
          addToast("You do not have permission to start this inspection", {
            autoDismiss: true,
            appearance: ToastStatuses.Error,
          });
        } else {
          addToast(`Failed to Start Inspection ${errorData?.error?.message}`, {
            autoDismiss: true,
            appearance: ToastStatuses.Error,
          });
        }
      },
    },
  );

  return {
    isLoading: createInspectionStartedAtState.isLoading,
    createInspectionStartedAt: () => createInspectionStartedAt(),
  };
}
